import { computed } from "vue";
import { listboxGroupClasses } from "@/runtime/components/Listbox/listbox.styles";
import { useCombobox } from "./useCombobox";

export const useComboboxGroup = () => {
  const combobox = useCombobox();
  const classes = computed(() => listboxGroupClasses({ size: combobox.comboboxProps.value?.size }));
  return { classes };
};
